export const getAllowedOrigin = () => {
  if (window.location.hostname.endsWith('edreams.com')) {
    return 'https://www.edreams.net';
  }

  return 'https://www.edreams.com';
};
